/**
 * Calendar-day arithmetic on date-only values (`YYYY-MM-DD`).
 *
 * A date-only value has no timezone, so the sum is done on a UTC-anchored date and
 * the result is formatted from its UTC parts. It is never produced by slicing an ISO
 * timestamp: that pattern returns the wrong day when applied to a real instant, and
 * the repository bans it outright.
 */
export function addCalendarDays(value: string, days: number): string {
  const date = new Date(`${value}T00:00:00.000Z`);
  date.setUTCDate(date.getUTCDate() + days);
  const year = String(date.getUTCFullYear()).padStart(4, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
